import React from 'react';

import { Card, CardContent, CardHeader } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { usePatientIdFromURL } from '@/hooks/usePatientIdFromURL';
import { Queries } from '@/queries/Queries';
import { Button } from '@/uiKit/atoms/Button.tsx';

export const OnboardingManagement: React.FC = () => {
  const patientId = usePatientIdFromURL();
  const { t } = useTranslation();

  const skipOnboarding = Queries.qa.useSkipOnboarding();
  return (
    <Card>
      <CardHeader title={t('QaTools.onboarding')} />
      <CardContent>
        <Button
          variant="contained"
          onClick={() => skipOnboarding.mutate({ patientId })}
        >
          {t('QaTools.skipOnboarding')}
        </Button>
      </CardContent>
    </Card>
  );
};
